import schema from '../../graphql/schema.json';

const AssetTypeLabels = {
  WATER_HEATER: 'Water heater',
  WASHER: 'Clothes washer',
  DISHWASHER: 'Dishwasher',
  SINK: 'Sink',
  TOILET: 'Toilet',
  GENERIC: 'Generic / Other',
};

const EventTypeLabels = {
  DEVICE_CLAIMED: "Device claimed",
  DEVICE_FIRST_ONLINE: "First online",
  DEVICE_BACK_ONLINE: "Back online",
  DEVICE_DETECTED_OFFLINE: "Device offline",
  DEVICE_TILTED: "Check placement",
  DEVICE_TILT_CLEARED: "Placement restored",
  LOW_BATTERY: "Low battery",
  LEAK_DETECTED: "Leak detected",
  LEAK_CLEARED: "Leak cleared",
  DEVICE_REBOOTED: "Device rebooted",
  GENERIC_INFO: "Info",
  LOW_BATTERY_CLEARED: "Low battery cleared",
  DEVICE_DEACTIVATED: "Device deactivated",
  DEVICE_REACTIVATED: "Device reactivated",
  DEVICE_LOCATION_UPDATED: "Location updated",
  DEVICE_UPDATED: "Device updated",
};

const EventTypeSeverity = {
  DEVICE_CLAIMED: "info",
  DEVICE_FIRST_ONLINE: "success",
  DEVICE_BACK_ONLINE: "success",
  DEVICE_DETECTED_OFFLINE: "warning",
  DEVICE_TILTED: "warning",
  DEVICE_TILT_CLEARED: "info",
  LOW_BATTERY: "warning",
  LEAK_DETECTED: "error",
  LEAK_CLEARED: "info",
  DEVICE_REBOOTED: "info",
  GENERIC_INFO: "info",
  LOW_BATTERY_CLEARED: "info",
  DEVICE_DEACTIVATED: "warning",      // or "info" depending on your meaning
  DEVICE_REACTIVATED: "success",      // or "info"
  DEVICE_LOCATION_UPDATED: "info",
  DEVICE_UPDATED: "info",
};

const HealthStatusLabels = {
  OK: "OK",
  LOW_BATTERY: "Low battery",
  TILTED: "Check placement",
  OFFLINE: "Offline",
  LEAK: "Leak detected",
  UNKNOWN: "Unknown",
};

const HealthStatusSeverity = {
  OK: "success",
  LOW_BATTERY: "warning",
  TILTED: "warning",
  OFFLINE: "warning",
  LEAK: "error",
  UNKNOWN: "neutral",
};

function autoLabelFromEnumName(name) {
  // "WATER_HEATER" → "Water heater"
  return name
    .toLowerCase()
    .split('_')
    .map((part, i) =>
      i === 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part
    )
    .join(' ');
}

export function getAssetTypeOptions() {
  const raw = getEnumValuesWithDescriptions('AssetType'); // value-only list from schema
  return raw.map(({ value }) => ({
    value,
    label: AssetTypeLabels[value] || autoLabelFromEnumName(value),
  }));
}


export function getEnumValuesWithDescriptions(enumName) {
  const type = schema.data.__schema.types.find(
    (t) => t.kind === "ENUM" && t.name === enumName
  );
  if (!type) return [];

  return type.enumValues.map((ev) => ({
    value: ev.name,
    label: ev.description || ev.name,
  }));
}

export function getEventTypeOptions() {
  const raw = getEnumValuesWithDescriptions("EventType");
  return raw.map(({ value }) => ({
    value,
    label: EventTypeLabels[value] || autoLabelFromEnumName(value),
    severity: EventTypeSeverity[value] || "info",
  }));
}

export function getEventTypeMeta(type) {
  return {
    label: EventTypeLabels[type] || autoLabelFromEnumName(type),
    severity: EventTypeSeverity[type] || "info",
  };
}

export function getHealthStatusLabel(status) {
  if (!status) return "Unknown";
  return HealthStatusLabels[status] || autoLabelFromEnumName(status);
}

export function getHealthStatusSeverity(status) {
  return HealthStatusSeverity[status] || "neutral";
}

// "Alerts only" means: high-severity events (warning or error)
export const AlertEventTypes = new Set(
  Object.keys(EventTypeSeverity).filter((type) =>
    ["warning", "error"].includes(EventTypeSeverity[type])
  )
);
